/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarDtoFromJSON, CarDtoToJSON, } from './';
export function CarDtoListGenericServiceResultFromJSON(json) {
    return CarDtoListGenericServiceResultFromJSONTyped(json, false);
}
export function CarDtoListGenericServiceResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'result': !exists(json, 'result') ? undefined : (json['result'] === null ? null : json['result'].map(CarDtoFromJSON)),
        'errors': !exists(json, 'errors') ? undefined : json['errors'],
        'succeeded': !exists(json, 'succeeded') ? undefined : json['succeeded'],
    };
}
export function CarDtoListGenericServiceResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'result': value.result === undefined ? undefined : (value.result === null ? null : value.result.map(CarDtoToJSON)),
    };
}
